import { AxiosInstance, AxiosStatic } from 'axios'
import { ApiRoutesNames } from 'bets.oddprovider.lib.common.ts/api/routes'
import { IDbTask, IDbTaskExecOptions, IDbTaskExecResult } from 'bets.oddprovider.lib.common.ts/models'
import { IApiClientResult } from 'fwork-jsts-common/src/apiClient'
import { BaseApiClient } from 'fwork-jsts-common/src/apiClient'
import { FilterQuery } from 'mongoose'
import { store } from '../redux/store'

export class TasksApiClient extends BaseApiClient<IDbTask, any, FilterQuery<IDbTask>, IDbTask, IDbTask> {
  constructor(axios: AxiosStatic | AxiosInstance) {
    const dotEnvProductionState = store.getState().dotEnvProductionState
    const baseUrl = `${dotEnvProductionState.payload?.APIURL}${ApiRoutesNames.dbTasks}`
    super({
      apiUrl: baseUrl,
      axios,
    })
  }

  async exec(options: IDbTaskExecOptions): Promise<IApiClientResult<IDbTaskExecResult[]> | undefined> {
    const dotEnvProductionState = store.getState().dotEnvProductionState
    const response = await this.axios?.post(`${dotEnvProductionState.payload?.APIURL}${ApiRoutesNames.dbTasksExecReq}`, options)
    return response?.data
  }

  async import(file: any): Promise<IApiClientResult<IDbTaskExecResult[]>> {
    const dotEnvProductionState = store.getState().dotEnvProductionState
    const response = await this.axios?.post(`${dotEnvProductionState.payload?.APIURL}${ApiRoutesNames.dbTasksUpload}`, file, {
      headers: {
        'Content-Type': 'application/json'
      }
    })

    return {
      success: true,
      data: response?.data
    }
  }
}